export function initNavigation() {
  
  const nav = document.querySelector("#navigation");
  
  if (!nav) {
    return;
  }

  const toggleButton = nav.querySelector("#toggleButton")
  const navPanel = nav.querySelector("#navPanel");
  const navLinks = nav.querySelectorAll("[data-nav-link]");

  const closeNavigation = () => {
    navPanel.classList.remove("is-open");
    document.body.classList.remove("nav-open");
    toggleButton.setAttribute("aria-expanded", "false");
    toggleButton.setAttribute("aria-label", "Menue oeffnen");
    toggleButton.classList.remove("-open");
    navPanel.setAttribute("aria-hidden", "true");
  };

  const openNavigation = () => {
    navPanel.classList.add("is-open");
    document.body.classList.add("nav-open");
    toggleButton.setAttribute("aria-expanded", "true");
    toggleButton.setAttribute("aria-label", "Menue schliessen");
    toggleButton.classList.add("-open");
    navPanel.setAttribute("aria-hidden", "false");
  };

  toggleButton.addEventListener("click", () => {
    const isOpen = navPanel.classList.contains("is-open");

    if (isOpen) {
      closeNavigation();
      return;
    }

    openNavigation();
  });

  navLinks.forEach((link) => {
    link.addEventListener("click", closeNavigation);
  });

  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeNavigation();
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 1000) {
      closeNavigation();
    }
  });
}
